import { Box, Grid } from '@mui/material';
import Header from '../../components/Header';
import { useState, useEffect } from "react";
import ProfileOptions from './accountComponents/ProfileOptions';
import API from "../../api";
import { boxStyle } from '../../theme';

const ResellerAccount = () => {
    const [userResponse, setUserResponse] = useState({})

    useEffect(() => {
        API.getResellerOptions({})
        .then((response) => {
            setUserResponse(response.data);
        })
        .catch((error) => {
            console.error("[ResellerAccount] Errore nel recupero dei dati del dispositivo:", error);
        });
    }, []);


    return (
        <Box m="20px">
            <Header title={"Account Management"} />
            <Grid container spacing={2}>
                <Grid size={12}>
                    {/*<ConfigureAuth />*/}
                    <Box sx={{...boxStyle, height: 550}}>
                        <ProfileOptions userData={userResponse}/>
                    </Box>
                </Grid>
                <Grid size={9}>

                </Grid>
            </Grid>
            
        </Box>
    );
};

export default ResellerAccount;

